module.exports = __webpack_public_path__ + "img/Master Vision.864ffa85.png";